import React from 'react'

function Logout() {
    const handleLogout = () => {
        // Remove the token
        localStorage.removeItem('token'); // Or use cookies
        alert('Logged out successfully');
        // Redirect to login
        window.location.href = '/admin/login';
      };
  return (
    <div className='flex justify-center m-auto text-center mt-10'>
      <button onClick={handleLogout} className='border rounded px-2 bg-red-700 text-white'>Logout</button>
    </div>
  )
}

export default Logout
